import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const WatchlistIconSvg = (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.899 6C10.899 6 8.04125 6 7.22475 6C6.40826 6.00001 6.00001 6.40825 6 7.22475C6 8.04125 6 10.899 6 10.899M6 17.431V21.1053C6.00001 21.9218 6.40825 22.33 7.22475 22.33H10.899M17.431 22.33C17.431 22.33 20.2887 22.33 21.1053 22.33C21.9218 22.33 22.33 21.9218 22.33 21.1053C22.33 20.2887 22.33 17.431 22.33 17.431M22.33 10.899C22.33 10.899 22.33 8.04125 22.33 7.22475C22.33 6.40826 21.9218 6.00002 21.1053 6C20.2887 5.99999 17.431 6 17.431 6M7.3655 14.165C7.37 14.07 9.83 9.65 14.165 9.65C18.5 9.65 20.7 14.07 20.697 14.165C20.7 14.27 18.8005 18.4 14.165 18.4C9.52952 18.4 7.37 14.27 7.3655 14.165ZM14.165 12.2871C15.104 12.2871 16.043 13.226 16.043 14.165C16.043 15.104 15.104 16.043 14.165 16.043C13.226 16.043 12.2871 15.104 12.2885 14.165C12.2871 13.226 13.226 12.2871 14.165 12.2871Z"
            stroke="currentColor" strokeWidth="0.75"/>
    </svg>

)
const Watchlist: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} style={{fontSize: '40px'}}>
        {WatchlistIconSvg}
    </SvgIcon>
)
export default Watchlist
